var map = {
	"./check-status.js": "ffdb",
	"./connect.js": "e31b",
	"./index.js": "8908",
	"./studentmessage.js": "9e28",
	"./telefono.js": "cdab",
	"./templates.js": "c426",
	"./workflowAreas.js": "19c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ec1";